.stepper-card {
  display: flex;
  flex-flow: column wrap;
  gap: var(--mantine-spacing-md);
}

.slide {
  display: flex;
  flex: 0 1 auto;
  flex-flow: column wrap;
  gap: var(--mantine-spacing-sm);
}

.slide-actions {
  display: flex;
  &:empty {
    display: none;
  }
}

.question {
  font-size: var(--mantine-font-size-lg);
}

/* Empty class kept as a selector hook — referenced from OptionSlide.tsx as `classes.actionButtonContainer` */
.action-button-container {
  /* intentionally empty */
}

.option-button {
  --button-height: auto;
  width: 100%;
  height: 100%;
  padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);
  text-align: unset;
}

.option-button-label {
  flex: 1 0 0;
  white-space: unset;
}

.options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr));
  /* display: flex; */
  /* flex: 0 1 auto; */
  /* flex-flow: row wrap; */
  gap: var(--mantine-spacing-sm);
  width: calc(100cqw - var(--mantine-spacing-xl) * 2);
}

.option-content {
  display: grid;
  gap: var(--mantine-spacing-xs);
  line-height: 1.2;
}

.option-label {
  font-size: var(--mantine-font-size-md);
  font-weight: calc(var(--mantine-heading-font-weight) * 0.714);
}

.option-description {
  font-size: var(--mantine-font-size-sm);
  font-weight: 400;
  color: var(--mantine-color-dark-1);
}

.checkbox-group {
  display: inline-flex;
  flex-flow: row wrap;
  gap: var(--mantine-spacing-md);
  & > div {
    display: contents;
  }
}

.checkbox-card {
  flex: 0 1 fit-content;
  &[data-checked] {
    background: var(--mantine-color-dark-accent-8);
  }
}

.checkbox-content {
  display: grid;
  grid-template:
    'indicator label' min-content
    'indicator description' min-content / min-content auto;
  column-gap: var(--mantine-spacing-xs);
  /* align-content: baseline; */
  padding: var(--mantine-spacing-sm);
}

.checkbox-indicator {
  display: flex;
  grid-area: indicator;
  place-items: center;
}

.checkbox-label {
  grid-area: label;
  font-size: var(--mantine-font-size-lg);
  font-weight: calc(var(--mantine-heading-font-weight) * 0.857);
}

.checkbox-description {
  grid-area: description;
}
